import { Grid, Tooltip } from '@material-ui/core';
import BreadCrumbs from '../../../Core/Controls/Breadcrumb';
import DialogComp from '../../../Core/Modal/dialogModal';
import ReportGijgoGrid from '../../internal/ReportsScreens/GijgoForReportsScreen';
import AddEditMasterMess from './AddEditMasterMess';
import { useMemo, useState } from 'react';
import { SquareButton } from '../../../Core/FormInput/AppButton';
import ReactDOM from 'react-dom';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';

const baseColumns = [
    { field: 'action', sortable: false, title: `Action`, width: 70, filterable: false },

    { field: 'messageDescription', sortable: false, title: `Description` },
    { field: 'createdBy', sortable: false, title: `Created By`, width: 150 },
    { field: 'updatedBy', sortable: false, title: `Updated By`, width: 150 },
    { field: 'messageIsActive', sortable: false, title: `Is Active`, width: 200 }
];

const MasterMessageList = () => {
    const crumbs = [
        { name: 'Home', path: '/' },
        { name: 'Master Message', active: true }
    ];

    const [state, setState] = useState({
        showModal: false,
        record: {},
        isReload: ''
    });

    const baseUrl = `MessagesMaster/MessageMaster_List`;

    const handleModal = (flag, record) => {
        setState((st) => ({ ...st, showModal: flag, record: record || {} }));
    };

    const RelodGrid = () => {
        setState((st) => ({ ...st, isReload: new Date(), showModal: false, record: {} }));
    };

    const addButton = (gridRef, valueList) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="center" style={{ paddingRight: '7px' }}>
                <SquareButton
                    style={{
                        backgroundColor: '#183B68',
                        borderRadius: '20%',
                        width: '32px',
                        height: '32px',
                        textAlign: 'center',
                        padding: '0px 0px 0px 0px',
                        marginLeft: '20px'
                    }}
                    onClick={() => handleModal(true, null)}
                >
                    <AddIcon fontSize="small" style={{ color: 'white' }} />
                </SquareButton>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const editButton = () => (value, record) => {
        const spn = document.createElement('span');
        const lnk = (
            <Grid container justifyContent="space-evenly">
                <Tooltip title="Update" arrow>
                    <abbr style={{ textDecoration: 'none' }}>
                        <SquareButton
                            onClick={() => handleModal(true, record)}
                            style={{
                                backgroundColor: '#183B68',
                                borderRadius: '20%',
                                width: '32px',
                                height: '32px',
                                textAlign: 'center',
                                padding: '0px 0px 0px 0px'
                            }}
                        >
                            <EditIcon fontSize="small" style={{ color: 'white' }} />
                        </SquareButton>
                    </abbr>
                </Tooltip>
            </Grid>
        );
        ReactDOM.render(lnk, spn);
        return spn;
    };

    const columns = useMemo(() => {
        const tempCols = [...baseColumns];
        let actionCol = tempCols.find((element) => element.field === 'action');

        if (actionCol) {
            actionCol.renderer = editButton({});
        }

        return tempCols;
    }, []);

    return (
        <div style={{ padding: 0 }}>
            <BreadCrumbs crumbs={crumbs} />
            <div style={{ marginTop: '-10px' }}>
                <ReportGijgoGrid
                    dataConverter={(res) => ({
                        records: res.data?.list,
                        total: res.data?.total
                    })}
                    columns={columns}
                    getUrl={baseUrl}
                    AddBtn={addButton}
                    isReload={state.isReload}
                />
            </div>
            {state.showModal && (
                <DialogComp title={'Add Master Message'} maxWidth="xl" fullWidth={true} fullScreen onClose={() => handleModal(false, null)}>
                    <AddEditMasterMess data={state.record} onClose={RelodGrid} />
                </DialogComp>
            )}
        </div>
    );
};

export default MasterMessageList;
